/**
 * user-summary コンポーネント専用i18n定数
 */

export const USER_SUMMARY_I18N = {
  // パンくずリスト
  breadcrumb: {
    userList: $localize`:@@home.userSummary.breadcrumb.userList:ユーザー一覧`,
    summary: $localize`:@@home.userSummary.breadcrumb.summary:サマリー`,
  },

  // 曜日
  weekdays: {
    sun: $localize`:@@home.userSummary.weekdays.sun:日`,
    mon: $localize`:@@home.userSummary.weekdays.mon:月`,
    tue: $localize`:@@home.userSummary.weekdays.tue:火`,
    wed: $localize`:@@home.userSummary.weekdays.wed:水`,
    thu: $localize`:@@home.userSummary.weekdays.thu:木`,
    fri: $localize`:@@home.userSummary.weekdays.fri:金`,
    sat: $localize`:@@home.userSummary.weekdays.sat:土`,
  },

  // ブール値の表示
  boolValue: {
    present: $localize`:@@home.userSummary.boolValue.present:あり`,
    absent: $localize`:@@home.userSummary.boolValue.absent:なし`,
  },

  // データ上書きダイアログ
  overwriteDialog: {
    title: $localize`:@@home.userSummary.overwriteDialog.title:データの上書き`,
    message: $localize`:@@home.userSummary.overwriteDialog.message:この日付けに対してすでにアップロード済みのデータがあります。上書きしてよいですか？`,
  },

  // スナックバーメッセージ
  snackBar: {
    uploadSuccess: $localize`:@@home.userSummary.snackBar.uploadSuccess:データをアップロードしました`,
    close: $localize`:@@home.userSummary.snackBar.close:閉じる`,
  },

  // ボタン
  button: {
    close: $localize`:@@common.button.close:閉じる`,
    showMore: $localize`:@@home.userSummary.button.showMore:もっと見る`,
  },

  // PDFオプション
  pdfOptions: {
    notAvailable: $localize`:@@home.userSummary.pdfOptions.notAvailable:選択不可`,
    noneSelected: $localize`:@@home.userSummary.pdfOptions.noneSelected:選択なし`,
    selectedCount: (count: number) =>
      $localize`:@@home.userSummary.pdfOptions.selectedCount:${count}:count:件選択中`,
    gostDetail: $localize`:@@home.userSummary.pdfOptions.gostDetail:GOST詳細`,
  },

  // バリデーションエラーメッセージ
  validationError: {
    required: (label: string) =>
      $localize`:@@home.userSummary.validationError.required:${label}:label:は必須項目です。`,
    outOfRange: (label: string, min: number | string, max: number | string) =>
      $localize`:@@home.userSummary.validationError.outOfRange:${label}:label:は${min}:min:〜${max}:max:の範囲で入力してください。`,
    elementNotFound: (label: string) =>
      $localize`:@@home.userSummary.validationError.elementNotFound:${label}:label:のフォーム要素が見つかりませんでした。システム管理者にお問い合わせください。`,
    uploadFailed: $localize`:@@home.userSummary.validationError.uploadFailed:データベースへのアップロード中にエラーが発生しました。再度お試しください。`,
  },

  // ツールチップ
  tooltip: {
    displayData: (display: string) =>
      $localize`:@@home.userSummary.tooltip.displayData:表示データ：${display}:display:`,
    compareData: (compare: string) =>
      $localize`:@@home.userSummary.tooltip.compareData:対比データ：${compare}:compare:`,
  },

  // PDFエラーメッセージ
  pdfError: {
    sectionDocumentsMissing: $localize`:@@home.userSummary.pdfError.sectionDocumentsMissing:セクション情報が取得できませんでした。`,
    sectionDocumentNotFound: $localize`:@@home.userSummary.pdfError.sectionDocumentNotFound:セクション文書が見つかりませんでした。`,
    sectionIdMissing: $localize`:@@home.userSummary.pdfError.sectionIdMissing:セクション情報を再読み込みしてからお試しください。`,
    userDataMissing: $localize`:@@home.userSummary.pdfError.userDataMissing:出力対象のユーザーデータがありません。`,
    generateFailed: $localize`:@@home.userSummary.pdfError.generateFailed:PDFを生成できませんでした。再度お試しください。`,
  },
} as const;

/**
 * 曜日配列を取得するヘルパー関数
 */
export function getWeekdaysArray(): string[] {
  const w = USER_SUMMARY_I18N.weekdays;
  return [w.sun, w.mon, w.tue, w.wed, w.thu, w.fri, w.sat];
}

export type UserSummaryI18n = typeof USER_SUMMARY_I18N;
